import {DestroyRef, Directive, inject, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import { TogglzService } from '../services/togglz.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {API_ERRORS} from '@emm/core/util/api-constants';
import {NotificationService} from '@emm/shared/services/notification.service';

@Directive({
    selector: '[appFeatureToggle]'
})
export class FeatureToggleDirective {
    @Input()
    set appFeatureToggle(featureId: string) {
        this.updateView(featureId);
    }
    private readonly destroyRef: DestroyRef = inject(DestroyRef);


    constructor(private templateRef: TemplateRef<any>,
                private viewContainerRef: ViewContainerRef,
                private togglzService: TogglzService,
                private notificationService: NotificationService) { }

    private updateView(featureId: string): void {
        this.viewContainerRef.clear();

        // this.togglzService.isFeatureEnabled(featureId)
        //     .pipe(
        //         takeUntilDestroyed(this.destroyRef)
        //     )
        //     .subscribe({
        //             next: (res) => {
        //                 if (res) {
        //                     this.viewContainerRef.createEmbeddedView(this.templateRef);
        //                 }
        //             },
        //             error: (error) => {
        //                 this.notificationService.error(error?.error?.error?.message || API_ERRORS.GenericErrorMessage);
        //             }
        //         }
        //     );
    }
}
